import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "purpose",
    "purposePanel",
    "bankFields",
    "bankInput",
    "sectionPanel",
    "sectionInput",
  ]

  connect() {
    this.toggle()
  }

  toggle() {
    const purpose = this.purposeTarget.value

    this.purposePanelTargets.forEach((panel) => {
      panel.classList.toggle("d-none", panel.dataset.purpose !== purpose)
    })

    this.sectionPanelTargets.forEach((panel) => {
      const purposes = panel.dataset.purposes.split(" ")
      const visible = purposes.includes(purpose)
      panel.classList.toggle("d-none", !visible)
      panel.querySelectorAll("[data-business-plan-form-target='sectionInput']").forEach((input) => {
        input.disabled = !visible
      })
    })

    if (!this.hasBankFieldsTarget) return

    const bankFinancing = purpose === "bank_financing"
    this.bankFieldsTarget.classList.toggle("d-none", !bankFinancing)
    this.bankInputTargets.forEach((input) => {
      input.disabled = !bankFinancing
    })
  }
}
